export const defaultEntranceExamMinimumScorePct = '50';

export const CERTIFICATE_DISPLAY_BEHAVIOR = {
  earlyNoInfo: 'early_no_info',
  end: 'end',
  endWithDate: 'end_with_date',
};

export const normalizeCertificateDisplayBehavior = (value) => {
  if (!value || typeof value !== 'string') {
    return value;
  }

  if (Object.values(CERTIFICATE_DISPLAY_BEHAVIOR).includes(value)) {
    return value;
  }

  const normalizedValue = value.split('.').pop().toLowerCase();
  if (Object.values(CERTIFICATE_DISPLAY_BEHAVIOR).includes(normalizedValue)) {
    return normalizedValue;
  }

  return value;
};
